module.exports = __webpack_public_path__ + "static/media/hyundai-bumper_selected.71fc3069.svg";